class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.chartData = null;
    this.currentUnit = 'cm';
    this.letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    this.unitLabels = {
      'cm': '(CM)',
      'in': '(Inches)'
    };
  }

  connectedCallback() {
    if (!this.dataset.chart) return;
    
    this.chartData = JSON.parse(this.dataset.chart);
    this.renderHeader();
    this.renderTable();
    this.bindToggleEvents();
  }

  formatValue(num) {
    const rounded = this.roundSmart(num);
    return Number.isInteger(rounded) ? rounded : rounded.toFixed(1);
  }

  renderHeader() {
    const thead = this.querySelector('#sizechart-thead');
    if (!thead) return;
    
    let headerHTML = `<tr><th>${this.unitLabels[this.chartData.unit]}</th>`;
    this.chartData.sizes.forEach(size => {
      headerHTML += `<th>${size}</th>`;
    });
    headerHTML += '</tr>';
    
    thead.innerHTML = headerHTML;
  }

  renderTable() {
    const tbody = this.querySelector('#sizechart-tbody');
    if (!tbody) return;
    
    let bodyHTML = '';
    this.chartData.measurements.forEach((measurement, rowIndex) => {
      const letter = this.letters[rowIndex] || (rowIndex + 1);
      
      bodyHTML += `<tr>
        <td class="measurement-label">
          <span class="letter-label">${letter}.</span>
          ${measurement.label}
        </td>`;

      measurement.values.forEach((value) => {
        const cmValue = parseFloat(value);
        const inchValue = this.roundSmart(cmValue / 2.54);
        
        bodyHTML += `
          <td class="measurement-value" 
              data-cm="${cmValue}" 
              data-in="${inchValue}">
            <span class="value">${this.formatValue(cmValue)}</span>
          </td>`;
      });
      
      bodyHTML += '</tr>';
    });
    
    tbody.innerHTML = bodyHTML;
  }

  bindToggleEvents() {
    const toggleBtns = this.querySelectorAll('.unit-btn');
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchUnit(btn.dataset.unit);
      });
    });
  }

  switchUnit(unit) {
    if (this.currentUnit === unit) return;
    
    this.currentUnit = unit;
    
    // Update toggle buttons
    this.querySelectorAll('.unit-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.unit === unit);
    });
    
    // Update FIRST TH (unit header) - CM/Inches display
    const firstTh = this.querySelector('#sizechart-thead th:first-child');
    firstTh.textContent = this.unitLabels[unit];
    
    // Update table values
    this.querySelectorAll('.measurement-value').forEach(cell => {
      const cmValue = parseFloat(cell.dataset.cm);
      const rawValue = unit === 'cm' ? cmValue : parseFloat(cell.dataset.in);
      
      cell.querySelector('.value').textContent = this.formatValue(rawValue);
    });
  }

  roundSmart(num) {
    const rounded = Math.round(num * 10) / 10;
    return rounded % 1 === 0 ? Math.round(rounded) : rounded;
  }

  disconnectedCallback() {
    // Cleanup event listeners if needed
  }
}

customElements.define('sizechart-wrapper', SizeChart);